import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {NgPipesModule} from 'ngx-pipes';
import {DjangoSessionAuthenticationService} from '../shared/authorization/custom';
import {ProvincesService} from '../provinces/provinces.service';
import {StaticService} from '../consulta/static.service';
import {OffersService} from '../offers/offers.service';
import {UsersService} from '../account/users.service';
import {StatsService} from '../account/stats.service';
import {tap} from 'rxjs/operators';
import {GeneralMessages} from '../shared/services';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  providers: [OffersService, UsersService, StatsService]
})
export class AccountComponent implements OnInit, OnChanges {
  @Input() user;
  offers;

  constructor(private auth: DjangoSessionAuthenticationService, private provincesService: ProvincesService,
              private offer: OffersService, private staticS: StaticService, private messaging: GeneralMessages,
              private usersService: UsersService, private stats: StatsService) {
  }

  provinces;
  users;
  alloffers;
  project_types;
  offerToDelete;

  offerloaded = null;
  adminview = false;

  ngOnInit() {
    this.project_types = this.staticS.getDefaultProjectType();
    this.getProvinces().subscribe();
    console.log(this.user);
  }

  ngOnChanges(changes) {
    if (changes['user'] && changes['user'].currentValue) {
      this.offers = this.user.offers;
    }
  }

  ngDoCheck() {
    if(this.offerloaded != this.staticS.getSelectedOffer()){
      this.offerloaded = this.staticS.getSelectedOffer();
    }
  }

  logout() {
    this.auth.logout().subscribe();
  }

  adminView() {
    if  (!this.users || this.users.length == 0)
      this.getUsers().subscribe();
    if  (!this.alloffers || this.alloffers.length == 0)
      this.getOffers().subscribe();
    if (!this.adminview)
      this.adminview = true;
    else
      this.adminview = false;
    this.staticS.setAdminView(this.adminview);
  }

  deleteSelfUserData() {
    this.auth.deleteSelfUserData().subscribe();
  }

  selectSavedOffer(selectedoffer) {
    this.staticS.selectOffer(selectedoffer);
  }

  preDeleteOffer(offer) {
    this.offerToDelete = offer;
    const boundFunction = (function (...args) { // parenthesis are not necessary
      this.deleteOffer(...args);
    }).bind(this, offer, this.user.offers);
    this.messaging.warning('Estas seguro?', 'Se va a borrar la consulta ' + this.offerToDelete['referency_number'],
      'borrar', boundFunction);
  }

  deleteOffer(offer, offers) {
    this.offer.delete(offer, offers)
      .subscribe();
      //.subscribe(data => this.messaging.info('', 'Consulta eliminada correctamente'));
    this.offers = this.user.offers;
  }

  getProvinces() {
    return this.provincesService.get().pipe(
      tap(data => {
        this.provinces = data;
      })
    );
  }

  getUsers() {
    return this.usersService.getAll(this.auth).pipe(
      tap(data => {
        this.users = data;
        this.stats.buildLineChartUsers(this.users);
        this.staticS.setAllUsers(this.users);
      })
    );
  }

  getOffers() {
    return this.offer.get().pipe(
      tap(data => {
        this.alloffers = data;
        this.stats.buildLineChartOffers(this.alloffers);
        this.staticS.setAllOffers(this.alloffers);
      })
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/account/account.component.ts